import { FC } from "react";
import { useOverlays } from "contexts/OverlayContext";
import { AddClientDrawer } from "@components/organizationView/clients/AddClient/AddClientDrawer";
import { noop } from "@common/helpers/function";
import { useActiveWorkspace } from "@hooks/useActiveWorkspace";
import { useLegacyPlusEntityLimit } from "@components/billing/LegacyPlusEntityLimit/useLegacyPlusEntityLimit";

export const AddEntityDrawerContainer: FC = () => {
    const { getOverlayInfo, closeOverlay, overlayIsClosing } = useOverlays();
    const overlayInfo = getOverlayInfo("addEntity");
    const activeWorkspace = useActiveWorkspace();
    const { isAtLimit } = useLegacyPlusEntityLimit();

    if (!overlayInfo?.data) {
        return null;
    }

    return (
        <AddClientDrawer
            key={overlayInfo.instanceId}
            open={!overlayIsClosing}
            onClose={closeOverlay}
            onAnimationEnd={noop}
            initialMode="addEntity"
            initialClientId={overlayInfo.data.workspaceId}
            isEntityLimitReached={
                isAtLimit &&
                overlayInfo.data.workspaceId === activeWorkspace?.id
            }
        />
    );
};
